<script>
	import { onMount } from 'svelte';
	import '../app.css';
	import Header from '$lib/components/Header.svelte';
	import Footer from '$lib/components/Footer.svelte';
	import BottomNav from '$lib/components/BottomNav.svelte';
	import InstallPrompt from '$lib/components/InstallPrompt.svelte';
	import LoadingOverlay from '$lib/components/LoadingOverlay.svelte';
	import { PWA } from '$lib/pwa.js';
	import { hydrateAuthHint } from '$lib/auth.svelte.js';

	let { children } = $props();

	// The public site is a plain website — it must NOT call the auth API just to label nav. Hydrate
	// the cached, non-authoritative signed-in hint from local storage (no network) so the footer /
	// mobile drawer reflect state. The authoritative /me check runs in the member-area layout.
	onMount(() => {
		hydrateAuthHint();
	});
</script>

<svelte:head>
	<meta property="og:site_name" content="St. Thomas Armenian Church" />
	<meta name="theme-color" content={PWA.themeColor} />
	<meta name="apple-mobile-web-app-title" content={PWA.shortName} />
	<link rel="apple-touch-icon" href={PWA.appleTouchIcon} />
</svelte:head>

<div class="flex min-h-screen flex-col bg-parchment">
	<Header />
	<main class="flex-1 pb-20 md:pb-0 md:pt-16">
		{@render children()}
	</main>
	<Footer />
	<BottomNav />
	<InstallPrompt />
</div>

<LoadingOverlay />
